(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5968],{

/***/ 60834:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/result",
      function () {
        return __webpack_require__(66527);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 72581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* reexport */ ModalReload; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/Modal/index.js
var Modal = __webpack_require__(178);
// EXTERNAL MODULE: ./components/ModalReload/modalReload.module.sass
var modalReload_module = __webpack_require__(50585);
var modalReload_module_default = /*#__PURE__*/__webpack_require__.n(modalReload_module);
// EXTERNAL MODULE: ./components/SpriteSVG/index.ts + 1 modules
var SpriteSVG = __webpack_require__(2708);
// EXTERNAL MODULE: ./components/Button/index.js + 1 modules
var Button = __webpack_require__(11866);
// EXTERNAL MODULE: ./providers/RootStoreProvider.jsx + 49 modules
var RootStoreProvider = __webpack_require__(8710);
;// CONCATENATED MODULE: ./components/ModalReload/ModalReload.jsx








var ModalReload = function() {
    var store = (0,RootStoreProvider/* useAuthStore */.tN)();
    var isManager = store.isManager;
    var router = (0,next_router.useRouter)();
    // Состояние для отслеживания видимости модального окна
    var ref = (0,react.useState)(false), isModalOpen = ref[0], setIsModalOpen = ref[1];
    // Состояние для хранения момента времени открытия страницы
    var ref1 = (0,react.useState)(new Date()), pageOpenTime = ref1[0];
    (0,react.useEffect)(function() {
        // Функция для проверки, прошло ли 15 минут
        var checkTime = function() {
            if (new Date() - pageOpenTime > 15 * 60 * 1000) {
                setIsModalOpen(true);
            }
        };
        // Запуск интервала
        var interval = setInterval(checkTime, 60 * 1000); // Проверяем каждую минуту
        // Очистка интервала
        return function() {
            return clearInterval(interval);
        };
    }, [
        pageOpenTime
    ]);
    // Функция для перезагрузки страницы
    var handleReload = function() {
        router.reload();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: !isManager && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* Modal */.u, {
            isOpen: isModalOpen,
            onOpen: setIsModalOpen,
            title: "Данные устарели",
            size: "dialog",
            centerHeader: true,
            hideCross: true,
            noClickAway: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (modalReload_module_default()).modalReload,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SpriteSVG/* IconSVG */.u, {
                        name: "common/reload",
                        width: 86,
                        height: 86
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: "Наличие мест и цены могли измениться."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                        view: "buttonModalData",
                        size: "lg",
                        onClick: handleReload,
                        children: "Перезагрузить страницу"
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/ModalReload/index.js



/***/ }),

/***/ 11711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ useHiddenWithCookie; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62286);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(nookies__WEBPACK_IMPORTED_MODULE_2__);



var useHiddenWithCookie = function(func) {
    var getCookie = (0,nookies__WEBPACK_IMPORTED_MODULE_2__.parseCookies)();
    var currentDate = dayjs__WEBPACK_IMPORTED_MODULE_1___default()();
    var timeEnd = dayjs__WEBPACK_IMPORTED_MODULE_1___default()(getCookie === null || getCookie === void 0 ? void 0 : getCookie.timeToOpenBanner);
    var timeToOpen = timeEnd <= currentDate;
    // eslint-disable-next-line consistent-return
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (timeToOpen) {
            func();
        }
    }, []);
};


/***/ }),

/***/ 66527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ ResultPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_useragent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(28010);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62286);
/* harmony import */ var nookies__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(nookies__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _providers_SearchStoreProvider__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(27101);
/* harmony import */ var _providers_RootStoreProvider__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8710);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(82913);
/* harmony import */ var _components_SearchPage__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(45692);
/* harmony import */ var _components_ModalReload__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(72581);
/* harmony import */ var _lib_yandexDataLayer__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(12406);
/* harmony import */ var _hooks_useHiddenWithCookie__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(11711);
















var BannerTop = next_dynamic__WEBPACK_IMPORTED_MODULE_6___default()(function() {
    return __webpack_require__.e(/* import() */ 9422).then(__webpack_require__.bind(__webpack_require__, 9422)).then(function(mod) {
        return mod.CookieBanner;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9422)
            ];
        }
    }
});
var __N_SSP = true;
function ResultPage(param) {
    var uaString = param.uaString, _store = param.store, user = _store.user, banners = _store.banners, cookies = _store.cookies, popularPopdirs = _store.popularPopdirs, canonicalUrl = param.canonicalUrl;
    var ua = (0,next_useragent__WEBPACK_IMPORTED_MODULE_2__/* .useUserAgent */ .FS)(uaString || window.navigator.userAgent);
    var isMobile = ua.isMobile, isTablet = ua.isTablet;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var type = router.query.type;
    var isSea = type === "sea" || router.asPath.startsWith("/sea_cruise");
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var ref, ref1;
        // Яндекс метрика - информация о пользователи и типе страницы
        (0,_lib_yandexDataLayer__WEBPACK_IMPORTED_MODULE_14__/* .yandexUserLayer */ .p$)(user === null || user === void 0 ? void 0 : (ref = user.user) === null || ref === void 0 ? void 0 : ref.id, user === null || user === void 0 ? void 0 : (ref1 = user.user) === null || ref1 === void 0 ? void 0 : ref1.group, isSea);
    // YaAndGaResultPage(isSea ? 'isSeaPage' : 'isRiverPage');
    }, [
        isSea
    ]);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((cookies === null || cookies === void 0 ? void 0 : cookies.closeBanner) !== undefined || (cookies === null || cookies === void 0 ? void 0 : cookies.closeBanner) === "false"), closeBanners = ref[0], setCloseBanners = ref[1];
    var currentDate = dayjs__WEBPACK_IMPORTED_MODULE_5___default()();
    var timeToCookie = currentDate.add(1, "h");
    (0,nookies__WEBPACK_IMPORTED_MODULE_3__.setCookie)(null, "closeBanner", "false");
    var openBanner = function() {
        setCloseBanners(false);
        (0,nookies__WEBPACK_IMPORTED_MODULE_3__.setCookie)(null, "closeBanner", "false");
    };
    (0,_hooks_useHiddenWithCookie__WEBPACK_IMPORTED_MODULE_13__/* .useHiddenWithCookie */ ._)(openBanner);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_providers_SearchStoreProvider__WEBPACK_IMPORTED_MODULE_8__/* .SearchStoreProvider */ .YG, {
        hydrationData: {
            user: user
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_providers_RootStoreProvider__WEBPACK_IMPORTED_MODULE_9__/* .RootStoreProvider */ .LD, {
            hydrationData: {
                user: user
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_7___default()), {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                            children: "Каталог"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "description",
                            content: "Каталог"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "robots",
                            content: "noindex, nofollow"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                            rel: "shortcut icon",
                            href: "/favicon.ico?v=2"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                            rel: "canonical",
                            href: canonicalUrl
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Layout__WEBPACK_IMPORTED_MODULE_10__/* .Layout */ .A, {
                    isMobile: isMobile,
                    isTablet: isTablet,
                    showTopContent: !closeBanners,
                    popularPopdirs: popularPopdirs,
                    topContent: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(BannerTop, {
                            isOpen: closeBanners,
                            onOpen: setCloseBanners,
                            timeToCookie: timeToCookie,
                            isMobile: isMobile,
                            isTablet: isTablet
                        })
                    }),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container--block",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SearchPage__WEBPACK_IMPORTED_MODULE_11__/* .SearchPage */ .Z, {
                            isMobile: isMobile,
                            isSea: isSea,
                            urlBanners: banners
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ModalReload__WEBPACK_IMPORTED_MODULE_12__/* .ModalReload */ .U, {})
            ]
        })
    });
};


/***/ }),

/***/ 50585:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"modalReload":"modalReload_modalReload__tK8LW"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [718,3215,1390,9774,2888,179], function() { return __webpack_exec__(60834); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);